const CommentType = [
    {
        "name": "Chitchat",
        "value": "chitchat",
        "color": "#5e5e5e",
        "message": "commented on the question you have practiced recently"

    }, {
        "name": "Cheer up",
        "value": "cheer-up",
        "color": "#29935a",
        "message": "cheered you up"

    }, {
        "name": "Team up",
        "value": "team-up",
        "color": "#24b4af",
        "message": "want's to teamed up with you"

    }, {
        "name": "Ask for help",
        "value": "ask-for-help",
        "color": "#b42492",
        "message": "asked for your help",
    }, {
        "name": "Experience Sharing",
        "value": "experience-sharing",
        "color": "#246cb4",
        "message": "shared an experience with you"
    }
]

export function getCommentType(value) {
    let type =  CommentType.find((type) => type.value === value);
    return type || CommentType[0]
}


export default CommentType